import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { Log } from "ng2-logger";
import { Equipment } from "@models/equipment.model";

@Component({
    selector: 'app-tool-main-equipment-form',
    templateUrl: './tool-main-equipment-form.component.html',
    styleUrls: ['./tool-main-equipment-form.component.scss']
})
export class ToolMainEquipmentFormComponent implements OnInit, OnChanges {
    _logger = Log.create(ToolMainEquipmentFormComponent.name);

    @Input() selectedMainEquipments: Equipment[] = [];
    @Input() availableMainEquipments: Equipment[] = [];
    @Input() showValidations = false;
    @Input() disabled = false;

    form: UntypedFormGroup;

    constructor() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['availableMainEquipments'] && this.form && this.selectedMainEquipments) {
            this.loadFormValues(this.selectedMainEquipments);
        }
    }

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.form = new UntypedFormGroup({
            selectedMainEquipments: new UntypedFormControl([]),
        });
    }

    loadFormValues(selectedMainEquipments: Equipment[]) {
        this.form.setValue({
            selectedMainEquipments: selectedMainEquipments
        })
    }


    resetForm() {
        this._logger.info("resetForm:: with", this.availableMainEquipments);
        this.showValidations = false;
        this.form.reset();
    }

    getFormValue() {
        return this.form.value;
    }

    get isFormValid() {
        this.showValidations = true;
        return this.form.valid;
    }
}
